<template>
	<div>
		<sub-header bizCd="05"/>
		 <div class="sub_visual sub07">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">제휴몰 사업</div>
                    <div class="comment">복지 포인트몰과 Mall in Mall 제휴, 사내 임직원 전용 교육몰 개설/운영 등을 통한 <br>
                        특별한 할인 혜택으로 임직원과 구성원의 만족을 더합니다.</div>
                    <div class="action pc_hidden">
                        <div><a href="//img.eduwill.net/resources/b2b/dev/에듀윌 임직원 전용 교육몰 서비스.pdf"
                        target="_blank" class="btn-1">교육몰 브로슈어<i class="icon icon-arrow"></i></a></div>
                    </div>
                </div>
            </div>
        </div>
		 <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <div class="sub_tit">
                        <p class="mx200">제휴몰 운영 과정</p>
                    </div>
                    <div class="con">
                        <div class="txt line02">기업 복지몰부터 기관 제휴몰까지,<br>다양한 과정으로 임직원의 미래설계까지 함께합니다.</div>
                        <div class="course_list">

                            <div class="course_box wide">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-license.png"
                                                alt="자격증" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-license@3x.png"
                                                alt="자격증" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">자격증</div>
                                    </div>
                                    <div class="co_contents wide04">
                                        <ul class="co_list">
                                            <li>・ 공인중개사</li>
                                            <li>・ 주택관리사</li>
                                            <li>・ 경비지도사</li>
                                            <li>・ 국제무역사</li>
<!--                                            <li>・ 도로교통사고감정사</li>-->
                                            <li>・ 물류관리사</li>
                                            <li>・ 사회복지사1급</li>
                                            <li>・ 유통관리사</li>
                                            <li>・ 손해평가사</li>
                                        </ul>
                                        <ul class="co_list">
                                            <li>・ 직업상담사</li>
                                            <li>・ 행정사</li>
                                            <li>・ 전기기사</li>
                                            <li>・ 전기기능사</li>
                                            <li>・ 소방시설관리사</li>
                                            <li>・ 소방설비기사</li>
                                            <li>・ 산업안전기사</li>
                                            <li>・ 건축기사</li>
                                        </ul>
                                        <ul class="co_list">
                                            <li>・ 토목기사</li>
                                            <li>・ 위험물산업기사</li>
                                            <li>・ 위험물기능사</li>
                                            <li>・ 정보처리기사</li>
                                            <li>・ IT자격증</li>
                                            <li>・ 전산세무회계</li>
                                            <li>・ 재경관리사</li>
                                            <li>・ ERP정보관리사</li>
                                        </ul>
                                        <ul class="co_list">
                                            <li>・ 매경TEST</li>
                                            <li>・ 한경TESAT</li>
                                            <li>・ 무역영어</li>
                                            <li>・ KBS한국어/글쓰기</li>
                                            <li>・ 한국사능력검정 </li>
<!--                                            <li>・ 세무사<i class="icon-new"></i></li>-->
<!--                                            <li>・ 공인회계사<i class="icon-new"></i> </li>-->
                                            <li>・ 감정평가사<i class="icon-new"></i> </li>
                                            <li>・ 공인노무사<i class="icon-new"></i> </li>
                                            <li>・ 대기환경기사</li>
                                            <li>・ 수질환경기사</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box wide">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-civil.png"
                                                alt="공무원" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-civil@3x.png"
                                                alt="공무원" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">공무원</div>
                                    </div>
                                    <div class="co_contents wide04">
                                        <ul class="co_list">
                                            <li>・ 9급공무원</li>
                                            <li>・ 소방공무원</li>
                                        </ul>
                                        <ul class="co_list">
                                            <li>・ 군무원</li>
                                            <li>・ 기술직 공무원</li>
                                            <li>・ 계리직 공무원</li>
                                        </ul>
                                        <ul class="co_list">
                                            <li>・ 운전직 공무원</li>
                                            <li>・ 교육행정직 공무원</li>
                                            <li>・ 법원/검찰/교정직 공무원</li>
                                        </ul>
                                        <ul class="co_list">
                                            <li>・ 사회복지직 공무원 </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box wide">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-advice.png"
                                                alt="취업 컨설팅" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-advice@3x.png"
                                                alt="취업 컨설팅" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">어학·취업·입시</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide04">
                                            <li>・ 공기업 취업</li>
                                            <li>・ 대기업 취업</li>
                                            <li>・ TOEIC<i class="icon-new"></i></li>
                                            <li>・ 대학편입<i class="icon-new"></i></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box wide">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-property.png"
                                                alt="교육 서비스" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-property@3x.png"
                                                alt="교육 서비스" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">교육 서비스 +</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide04">
                                            <li>・ 부동산아카데미</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="sec">
                    <div class="sub_tit">복지포인트몰<br class="m_hidden">제휴</div>
                    <div class="con">
                        <div class="txt txt_line2">복지포인트몰과 Mall in Mall 제휴를 통하여<br>
                            임직원은 전용 포인트로 에듀윌 교육 상품을 특별 할인가에 구매할 수 있습니다.</div>
                        <div class="partnership_wrap">
                            <div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/pointmall_1.png"
                                    alt="특별이벤트" /></div>
                            <div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/pointmall_2.png"
                                    alt="특별이벤트" /></div>
                        </div>
                    </div>
                </div>

                <div class="sec">
                    <div class="sub_tit">기업 임직원<br class="m_hidden">교육몰 제휴</div>
                    <div class="con">
                        <div class="txt txt_line2">임직원이 특별 할인가로 구매할 수 있는 임직원 전용 교육몰입니다.<br>
                            짧은 시간, 간단한 방법으로 임직원 복지 혜택을 제공할 수 있습니다. </div>
                        <div class="partnership_wrap">
                            <div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/edumall_1.png"
                                    alt="특별이벤트" /></div>
                            <div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/edumall_2.png"
                                    alt="특별이벤트" /></div>
                        </div>
                    </div>
                </div>


                <div class="sec">
                    <div class="sub_tit">특별 이벤트</div>
                    <div class="con">
                        <div class="txt">상시로 진행되는 이벤트로 임직원 여러분에게 특별한 플러스(+) 서비스를 제공합니다.</div>
                        <div class="partnership_wrap">
                            <div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/event01.png"
                                    alt="특별이벤트" /></div>
                            <div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/event02.png"
                                    alt="특별이벤트" /></div>
                        </div>
                    </div>
                </div>
                <div class="sec">
                    <div class="clearfix">
                        <div class="sub_tit">콘텐츠 제휴 Flow</div>
                    </div>
                    <div class="con_wide">

                        <!-- flow PC -->
                        <div class="flow_common flow_m_hidden">
                            <div class="f_wrap">
                                <div class="step01 aos-item" data-aos="fade-right" data-aos-delay="300"
                                    data-aos-offset="0"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img-flow-02-01-01.png"
                                        alt="고객사" /></div>
                                <div class="step02 flow_line aos-item" data-aos="fade-right" data-aos-delay="450"
                                    data-aos-offset="0">
                                    <div class="text">제휴 문의</div>
                                    <div class="arrow_right"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표" />
                                    </div>
                                    <div class="arrrow_left"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png"
                                            alt="flow화살표" /></div>
                                    <div class="text">임직원몰 구축, 운영</div>
                                </div>
                                <div class="step03 aos-item" data-aos="fade-right" data-aos-delay="600"
                                    data-aos-offset="0">
                                    <div class="step_edu">
                                        <div class="step_edu_con">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png" />
                                            <p>에듀윌</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="step04 flow_line aos-item" data-aos="fade-right" data-aos-delay="750"
                                    data-aos-offset="0">
                                    <div class="text">교육서비스 제공</div>
                                    <div class="arrow_right"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표" />
                                    </div>
                                    <div class="arrrow_left"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png"
                                            alt="flow화살표" /></div>
                                    <div class="text">수강문의, 상담</div>
                                </div>
                                <div class="step05 aos-item" data-aos="fade-right" data-aos-delay="900"
                                    data-aos-offset="0"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img-flow-03-02-03.png"
                                        alt="수강생" /></div>
                            </div>
                        </div>

                        <!-- flow Mobile  -->
                        <div class="flow_common flow_pc_hidden">
                            <div class="f_wrap">
                                <div class="wide">
                                    <div class="step_edu aos-item" data-aos="fade-right" data-aos-delay="450"
                                        data-aos-offset="0">
                                        <div class="step_edu_con">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png" />
                                            <p>에듀윌</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="stepper">
                                    <div class="img_left aos-item" data-aos="fade-right" data-aos-delay="300"
                                        data-aos-offset="0">
                                        <div class="flow_mo_left">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/flow03_2_left.png" />
                                        </div>
                                    </div>
                                    <div class="img_right aos-item" data-aos="fade-right" data-aos-delay="600"
                                        data-aos-offset="0">
                                        <div class="flow_mo_right">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/flow03_2_right.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="sub_partner">
                <div class="container">
                    <div class="title_line">
                        <div class="pa_tit">Partner</div>
                        <div class="text">에듀윌과 함께하는 제휴몰 파트너사입니다.</div>
                    </div>
                    <ul class="pa_slider_scroll">
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/03_2/ci_36_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/03_2/ci_37_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/03_2/ci_38_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/03_2/ci_39_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/03_2/ci_40_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/03_2/ci_41_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/03_2/ci_01.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/03_2/ci_02.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/03_2/ci_03.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/03_2/ci_04.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/03_2/ci_05.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/03_2/ci_06.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/03_2/ci_07.png" /></li>
                    </ul>
                </div>
            </div>
		</div>
    <div class="float_counsel m_hidden">
        <div class="group-wrap">
            <div class="group">
                <div class="text">임직원 전용<br>에듀윌 교육몰</div>
                <div class="button"><a href="//img.eduwill.net/resources/b2b/dev/에듀윌 임직원 전용 교육몰 서비스.pdf"
                        target="_blank">브로슈어 다운로드</a>
                </div>
                <div class="ico-hand"></div>
            </div>
            <div class="group">
                <div class="text">에듀윌과 함께<br>변화를 시작하세요.</div>
                <div class="button" @click="showCounsel('01')"><a href="javascript:;" @click="show_counsel('01')">맞춤상담신청</a></div>
                <div class="ico-hand"></div>
            </div>
        </div>
    </div>
    <div class="float_counsel_mobile pc_hidden">
		<a class="circle_counsel" @click="showCounsel('01')">맞춤<br>상담</a>
    </div>
	</div>
</template>

<script>
import SubHeader from "@/layouts/SubHeader";
import eventBus from "@/eventBus/event-bus";

export default {
	name: "cpMallEduSell.vue",
	components: {SubHeader},
	data() {
		return {}
	},
	
	computed: {
	},
	
	methods: {
		showCounsel(v) {
			eventBus.$emit("show-counsel", v);
		},
		closeCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup().close();
		},
		showCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup();
		}
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
}
</script>

<style scoped>

</style>
